// Boost Blenz Admin — shared avatar.
//
// 🔴 THIS FILE USED TO HOLD THE DESIGN PROTOTYPE'S App Health and Customers screens — mock
// numbers from data/admin.ts, a customer drawer with "Send push" (which only navigated
// away), "Suppress" and "View in Shopify" buttons with no handlers at all, and four
// notification toggles wired to local React state that nothing saved and nothing read.
// They stopped being routed when App Health and Customers moved onto the tracker's real
// database (views/apptracking.tsx), but the code stayed, still importable, still looking
// like it worked. Deleted 2026-09-10. The one thing anything still used is below.
import React from "react";
import { OSWALD, useT } from "../theme";

export function Avatar({ name, featured, size = 32 }: any) {
  const t = useT();
  const initials = name.split(' ').map((n) => n[0]).join('').slice(0, 2);
  return (
    <div style={{ width: size, height: size, borderRadius: 999, background: featured ? t.accent : t.purpleSoft, color: featured ? '#fff' : t.purple,
      display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: OSWALD, fontWeight: 700, fontSize: size * 0.4, flexShrink: 0, letterSpacing: '0.02em' }}>{initials}</div>
  );
}
